import { Box, ToggleButton, Tooltip as TooltipRoot } from '@mui/material'
import {
  Controller,
  FieldPath,
  FieldValues,
  Path,
  PathValue,
  useFormContext,
} from 'react-hook-form'

import { FlexBox } from 'components/Box'
import { Switch } from 'components/Form'
import Tooltip from 'components/Tooltip'
import { SwitchWithAutoButtonProps } from './types'

export const SwitchWithAutoButton = <T extends FieldValues>({
  autoButtonHint,
  autoDisabled,
  control,
  disabled,
  label,
  name,
  switchButtonHint,
  tooltip,
}: SwitchWithAutoButtonProps<T>): React.JSX.Element => {
  const { setValue, watch } = useFormContext<T>()

  const isAutoEnabled: boolean = watch(`${name}AutoEnabled` as Path<T>)

  return (
    <FlexBox axis='x'>
      <Switch
        control={control}
        disabled={disabled || isAutoEnabled}
        label={label}
        labelPlacement='start'
        name={`${name}Enabled`}
        tooltip={{ content: switchButtonHint || '' }}
        tooltipMode='wrap'
      />

      <Controller
        control={control}
        name={`${name}AutoEnabled` as FieldPath<T>}
        render={({ field: { onChange, value } }): React.JSX.Element => (
          <FlexBox axis='x'>
            <TooltipRoot
              arrow
              placement='top-start'
              title={autoButtonHint}
            >
              <Box>
                <ToggleButton
                  color='info'
                  disabled={disabled || autoDisabled}
                  name={`${name}AutoEnabled` as FieldPath<T>}
                  onChange={(_, newValue: boolean): void => {
                    if (!newValue) {
                      setValue(`${name}Enabled` as Path<T>, true as PathValue<T, Path<T>>)
                    }
                    onChange(!newValue)
                  }}
                  selected={value}
                  value={value}
                >
                  {'auto'.toUpperCase()}
                </ToggleButton>
              </Box>
            </TooltipRoot>

            {tooltip && <Tooltip {...tooltip} />}
          </FlexBox>
        )}
      />
    </FlexBox>
  )
}
